import { createSelector } from "reselect";
import { IMobileAppRootState } from "../../mobileAppCore/types/mobileAppState.t";
import { TAnimationEventName } from "./animation.t";

const moduleSelector = (state: IMobileAppRootState) => state.animation;

export const makeSelectShownAnimationsOnEventByName = (eventName: TAnimationEventName) =>
    createSelector(moduleSelector, (state) => {
        return state.shownAnimationsOnEvent[eventName];
    });
